import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "src/components/common/ProtectedAdminRoute";
import LoginPage from "./LoginPage";

import { adminRoutes } from "./routes.config";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {adminRoutes.map((r, idx) => (
        <Route
          key={idx}
          path={r.path}
          element={<ProtectedRoute>{r.element}</ProtectedRoute>}
        />
      ))}

      {/* Fallback redirect */}
      <Route path="/*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
